import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import { useGetPublicplansQuery } from '../../slices/teachers/planApiSlice';
import { useUpdateSubjectMutation } from '../../slices/teachers/subjectApiSlice';
import { useUpdatePlanMutation } from '../../slices/teachers/planApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherEditSubject = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { id } = useParams();

    const [tittle, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const [subtopic1, setSubtopic1] = useState('');
    const [subtopic2, setSubtopic2] = useState('');
    const [subtopic3, setSubtopic3] = useState('');
    const [subtopic4, setSubtopic4] = useState('');
    const [subtopic5, setSubtopic5] = useState('');
    const [subtopic6, setSubtopic6] = useState('');
    const [subtopic7, setSubtopic7] = useState('');
    const [subtopic8, setSubtopic8] = useState('');
    const [subtopic9, setSubtopic9] = useState('');

    const [questions1, setQuestions1] = useState(undefined);
    const [price1, setPrice1] = useState('');
    const [active1, setActive1] = useState();
    const [deactive1, setDeactive1] = useState();
    const [questions2, setQuestions2] = useState('');
    const [price2, setPrice2] = useState('');
    const [active2, setActive2] = useState();
    const [deactive2, setDeactive2] = useState();
    const [questions3, setQuestions3] = useState('');
    const [price3, setPrice3] = useState('');    
    const [active3, setActive3] = useState();
    const [deactive3, setDeactive3] = useState();

    const [isvideo, setIsvideo] = useState(false); 
    const [videoFile, setVideoFile] = useState(null); 
    const [loading, setLoading] = useState(false); 

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const { data, error, isLoading } = useGetPublicsubjectQuery(id);

    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplansQuery(id);

    const [updateSubject, { isLoading: loadingUpdateSubject }] = useUpdateSubjectMutation();

    const [updatePlan, { isLoading: loadingUpdatePlan }] = useUpdatePlanMutation();

    const goToProfile = () => {
        window.open(`${window.location.origin}/teacherpublicsubject/${data?._id}`, '_blank')
      }

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo]);

    
    useEffect(() => {
        setTitle(data?.tittle);
        setDescription(data?.description);
        setSubtopic1(data?.subtopics.subtopic1);
        setSubtopic2(data?.subtopics.subtopic2);
        setSubtopic3(data?.subtopics.subtopic3);
        setSubtopic4(data?.subtopics.subtopic4);
        setSubtopic5(data?.subtopics.subtopic5);
        setSubtopic6(data?.subtopics.subtopic6);
        setSubtopic7(data?.subtopics.subtopic7);
        setSubtopic8(data?.subtopics.subtopic8);
        setSubtopic9(data?.subtopics.subtopic9);
        if (plansIsLoading === false) {
            setQuestions1(plansData[0]?.totalQuestions);
            setPrice1(plansData[0]?.price);
            setActive1(plansData[0]?.active);
            setDeactive1(plansData[0]?.deactive);
            setQuestions2(plansData[1]?.totalQuestions);
            setPrice2(plansData[1]?.price);
            setActive2(plansData[1]?.active);
            setDeactive2(plansData[1]?.deactive);
            setQuestions3(plansData[2]?.totalQuestions);
            setPrice3(plansData[2]?.price);
            setActive3(plansData[2]?.active);
            setDeactive3(plansData[2]?.deactive);

        }
      }, [data?.tittle, data?.description,  data?.subtopics.subtopic1, plansIsLoading]);


      const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          if (file.type == 'video/mp4' ||  file.type == 'video/quicktime' || file.type == 'video/avi') { 
            setIsvideo(true); 
            setVideoFile(event.target.files[0]); 
          } else {  
            toast.error('Please upload a mp4 or quicktime or avi video file ');
          }
        } 
      };

      const handleactive1Change = (event, activate) => {
        const CheckedVal = event.target.checked;

        if (activate == 'activate1') {
            setActive1(CheckedVal);
            setDeactive1(!CheckedVal);
        }
        if (activate == 'deactive1') {
            setDeactive1(CheckedVal);
            setActive1(!CheckedVal);
        }

        if (activate == 'activate2') {
            setActive2(CheckedVal);
            setDeactive2(!CheckedVal);
        }
        if (activate == 'deactive2') {
            setDeactive2(CheckedVal);
            setActive2(!CheckedVal);
        }

        if (activate == 'activate3') {
            setActive3(CheckedVal);
            setDeactive3(!CheckedVal);
        }
        if (activate == 'deactive3') {
            setDeactive3(CheckedVal);
            setActive3(!CheckedVal);
        }
      };

    const submitHandler = async (e) => {
        e.preventDefault()
        setLoading(true);
        if (tittle == '') { toast.error('Please enter title'); return; } 
        if (description == '') { toast.error('Please enter  description'); return; }
        if (subtopic1 == '' && subtopic2 == '' && subtopic3 == '' && subtopic4 == '' && subtopic5 == '' && subtopic6 == '' && subtopic7 == '' && subtopic8 == '' && subtopic9 == '') { 
            toast.error('Please setup at least one Subtopic '); 
            return; 
        }
        if (price1 == '' && price2 == '' && price3 == '') { toast.error('Please setup at least one subscription plan '); return; }
        try {
            const res = await updateSubject({ 
                id,
                tittle, 
                description, 
                subtopics: {
                    subtopic1, 
                    subtopic2, 
                    subtopic3, 
                    subtopic4, 
                    subtopic5,
                    subtopic6,
                    subtopic7,
                    subtopic8,
                    subtopic9 
                }
            }).unwrap();
            let teachername = res.teacherName;
            let subjectname = res.tittle;   
            let subjectId = res.id;
            const res2 = await updatePlan({
                plansData,
                questions1,
                price1,
                active1,
                deactive1,
                questions2,
                price2,
                active2,
                deactive2,
                questions3,
                price3,
                active3,
                deactive3,
                teachername,
                subjectname,
                subjectId
            }).unwrap();
            if (isvideo) {
                var fd = new FormData();
                fd.append('upl', videoFile);
                fd.append('id', subjectId);
                fetch('/api/upload/uploadsubjectvideo',
              {
                  method: 'post',
                  body: fd,
                })
                .then(response => response.json())
                .then(data => {
                  toast.success('Video Saved');
                  setLoading(false);
                })
                .catch(error => {
                  toast.success('Error uploading video');
                  setLoading(false);
                });
              } else {  
                toast.error('Please upload a mp4 or quicktime or avi video file');  
              }
            toast.success('Subject Saved');
            navigate('/teachersubjects')
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    };

    return (
        <div>
            <TeacherNavbar />
            <div className="main-content" id="panel">
                <TeacherHeader /><br /><br /><br /><br /><br />
                <div className="container-fluid mt--6">
                    <div className="row">
                    <div className="col-xl-10 offset-xl-1 newSubj ">  
                    <div className="card-wrapper">
                                <div className="card ">
                                    {isLoading || loading ? ( 
                                        <Loader />
                                    ) : error ? (
                                        <Message variant='danger'>
                                            {error?.data?.message || error.error}
                                        </Message>
                                    ) : (
                                        <div className="card-body"><br />
                                            <Form onSubmit={submitHandler}>
                                            <h1 className="mb-0 centerTitle  tittleColor4">
                                            <span className='tittleColor'>
                                                Edit Subject
                                            </span>
                                                </h1><br />
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Title:</h6>   
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="  Title" 
                                                            type="text" 
                                                            style={{textTransform: 'capitalize'}}
                                                            value={tittle}
                                                            onChange={(e) => setTitle(e.target.value)}                                              
                                                        />
                                                    </div>
                                                </div><br />
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Description:</h6>   
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-warning"><i className="ni ni-archive-2 navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder="  Description" 
                                                            rows="3"
                                                            value={description}
                                                            onChange={(e) => setDescription(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div><br />

                                                <div className="form-group">
                                                <label for="exampleInputEmail1">Upload a video describing your subject</label>

                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                    <div className="input-group-prepend moveInput">
                                                    <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                    </div>                                                
                                                    <input 
                                                    type="file" 
                                                    className="form-control" 
                                                    onChange={handleFileChange} 
                                                    />
                                                    </div>
                                                </div><br />
                                                <div className=""><br />
                                                    <h4 className="mb-0 centerTitle  tittleColor4">
                                                    <span className='tittleColor'>
                                                        Subtopics your stutends can ask you about
                                                    </span>
                                                        </h4><br /><br />
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 1" 
                                                            rows="3"
                                                            value={subtopic1}
                                                            onChange={(e) => setSubtopic1(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 2" 
                                                            rows="3"
                                                            value={subtopic2}
                                                            onChange={(e) => setSubtopic2(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 3" 
                                                            rows="3"
                                                            value={subtopic3}
                                                            onChange={(e) => setSubtopic3(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 4" 
                                                            rows="3"
                                                            value={subtopic4}
                                                            onChange={(e) => setSubtopic4(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 5" 
                                                            rows="3"
                                                            value={subtopic5}
                                                            onChange={(e) => setSubtopic5(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 6" 
                                                            rows="3"
                                                            value={subtopic6}
                                                            onChange={(e) => setSubtopic6(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 7" 
                                                            rows="3"
                                                            value={subtopic7}
                                                            onChange={(e) => setSubtopic7(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 8" 
                                                            rows="3"
                                                            value={subtopic8}
                                                            onChange={(e) => setSubtopic8(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-ungroup navText"></i></span>
                                                        </div>
                                                        <textarea 
                                                            className="form-control emailForm" 
                                                            placeholder=" Enter Subtopic 9" 
                                                            rows="3"
                                                            value={subtopic9}
                                                            onChange={(e) => setSubtopic9(e.target.value)}                                          
                                                        />
                                                    </div>
                                                </div><br />
                                                <div className=""><br />
                                                    <h4 className="mb-0 centerTitle  tittleColor4">
                                                    <span className='tittleColor4'>
                                                        Create subject subscription plans ( up to 3 )
                                                    </span>
                                                        </h4>
                                                        <p className=" text-info text-center small">
                                                        You need to setup your payments account to start receiving subscribers and payments
                                                        </p>
                                                        <br /><br />
                                                </div>
                                                <div className=""><br />
                                                    <h5 className="mb-0 centerTitle  tittleColor4">
                                                    <span className='tittleColor4'>Plan 1
                                                    </span>
                                                        </h5><br /><br />
                                                </div>
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Plan 1 Monthly Questions:</h6>
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-info"><i className="ni ni-ui-04 navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="  Number of Questions a student can ask you" 
                                                            type="text" 
                                                            value={questions1}
                                                            onChange={(e) => setQuestions1(e.target.value)}                                              
                                                        />
                                                    </div>
                                                </div><br />
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Plan 1 Monthly Price:</h6>
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-success"><i className="ni ni-shop navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="  Monthly Price " 
                                                            type="text" 
                                                            value={price1}
                                                            onChange={(e) => setPrice1(e.target.value)}                                              
                                                        />
                                                    </div><br />
                                                    <h6 className="" placeholder="  Plan Name" type="text">Activate Plan 1</h6>
                                                    <div className=" mb-3">
                                                        <input 
                                                            className="" 
                                                            id="customCheck1" 
                                                            type="checkbox"  
                                                            value={active1}
                                                            onChange={(e) => handleactive1Change(e, 'activate1' )}  
                                                            checked={active1}
                                                        />
                                                        <label className="select11" htmlFor="customCheck1">
                                                            Select  if you want to continue  accepting new students for this plan 
                                                        </label>
                                                    </div>
                                                    <h6 className="" placeholder="  Plan Name" type="text">Deactivate Plan 1</h6>
                                                    <div className=" mb-3">
                                                        <input 
                                                            className="" 
                                                            id="customCheck11" 
                                                            type="checkbox"  
                                                            value={deactive1}
                                                             onChange={(e) => handleactive1Change(e, 'deactive1')}  
                                                            checked={deactive1}
                                                        />
                                                        <label className="select11" htmlFor="customCheck11">
                                                            Select  if you want to  stop accepting new students for this plan 
                                                        </label>
                                                    </div>
                                                </div><br /><br />
                                                <div className=""><br />
                                                    <h5 className="mb-0 centerTitle  tittleColor4">
                                                    <span className='tittleColor4'>
                                                        Plan 2
                                                    </span>
                                                        </h5><br /><br />
                                                </div>
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Plan 2 Monthly Questions:</h6>
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-info"><i className="ni ni-ui-04 navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="  Number of Questions a student can ask you" 
                                                            type="text" 
                                                            value={questions2}
                                                            onChange={(e) => setQuestions2(e.target.value)}                                              
                                                        />
                                                    </div>
                                                </div><br />
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Plan 2 Monthly Price:</h6>
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-success"><i className="ni ni-shop navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="  Monthly Price " 
                                                            type="text" 
                                                            value={price2}
                                                            onChange={(e) => setPrice2(e.target.value)}                                              
                                                        />
                                                    </div>
                                                </div><br />                                                
                                                    <h6 className="" placeholder="  Plan Name" type="text">Activate Plan 2</h6>
                                                    <div className=" mb-3">
                                                        <input 
                                                            className="" 
                                                            id="customCheck2" 
                                                            type="checkbox"  
                                                            value={active2}
                                                            onChange={(e) => handleactive1Change(e, 'activate2' )}  
                                                            checked={active2}
                                                        />
                                                        <label className="select11" htmlFor="customCheck2">
                                                            Select  if you want to continue  accepting new students for this plan 
                                                        </label>
                                                    </div>
                                                    <h6 className="" placeholder="  Plan Name" type="text">Deactivate Plan 2</h6>
                                                    <div className=" mb-3">
                                                        <input 
                                                            className="" 
                                                            id="customCheck22" 
                                                            type="checkbox"  
                                                            value={deactive2}
                                                             onChange={(e) => handleactive1Change(e, 'deactive2')}  
                                                            checked={deactive2}
                                                        />
                                                        <label className="select11" htmlFor="customCheck22">
                                                            Select  if you want to  stop accepting new students for this plan 
                                                        </label>
                                                    </div>
                                                <div className=""><br /><br />
                                                    <h5 className="mb-0 centerTitle  tittleColor4">
                                                    <span className='tittleColor4'>
                                                        Plan 3
                                                    </span>                                                    
                                                        </h5><br /><br />
                                                </div>
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Plan 3 Monthly Questions:</h6>
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-info"><i className="ni ni-ui-04 navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="  Number of Questions a student can ask you" 
                                                            type="text" 
                                                            value={questions3}
                                                            onChange={(e) => setQuestions3(e.target.value)}                                              
                                                        />
                                                    </div>
                                                </div><br />
                                                <div className="form-group">
                                                    <h6 className="" placeholder="  Plan Name" type="text">Plan 3 Monthly Price:</h6>   
                                                    <div className="input-group input-group-merge input-group-alternative mb-3">
                                                        <div className="input-group-prepend moveInput">
                                                        <span className="input-group-text bg-gradient-success"><i className="ni ni-shop navText"></i></span>
                                                        </div>
                                                        <input 
                                                            className="form-control emailForm" 
                                                            placeholder="  Monthly Price " 
                                                            type="text" 
                                                            value={price3}
                                                            onChange={(e) => setPrice3(e.target.value)}                                              
                                                        />
                                                    </div><br />                                                  
                                                    <h6 className="" placeholder="  Plan Name" type="text">Activate Plan 3</h6>
                                                    <div className=" mb-3">
                                                        <input 
                                                            className="" 
                                                            id="customCheck3" 
                                                            type="checkbox"  
                                                            value={active3}
                                                            onChange={(e) => handleactive1Change(e, 'activate3' )}  
                                                            checked={active3}
                                                        />
                                                        <label className="select11" htmlFor="customCheck3">
                                                            Select  if you want to continue  accepting new students for this plan 
                                                        </label>
                                                    </div>
                                                    <h6 className="" placeholder="  Plan Name" type="text">Deactivate Plan 3</h6>
                                                    <div className=" mb-3">
                                                        <input 
                                                            className="" 
                                                            id="customCheck33" 
                                                            type="checkbox"  
                                                            value={deactive3}
                                                             onChange={(e) => handleactive1Change(e, 'deactive3')}  
                                                            checked={deactive3}
                                                        />
                                                        <label className="select11" htmlFor="customCheck33">
                                                            Select  if you want to  stop accepting new students for this plan 
                                                        </label>
                                                    </div>
                                                </div><br /><br />                                        
                                                <div className="mycard"><br />
                                                    <div className="row">
                                                        <div className="col-xl-6 ">
                                                            <Button  type='submit' variant="success rounded-pill bg-gradient-success btn-lg "> 
                                                                Update Subject  
                                                            </Button><br /><br /><br />
                                                        </div>
                                                        <div className="col-xl-6">
                                                            <Button   onClick={goToProfile} variant="primary rounded-pill bg-gradient-primary btn-lg "> 
                                                            View Subject Page 
                                                            </Button><br /><br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>
                                    )} 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeacherEditSubject
